import {
  FETCH_PEM_SUMMARY_COST_DATA_REQUEST,
  GET_PEM_SUMMARY_COST_DATA_SUCCESS,
  GET_PEM_SUMMARY_COST_DATA_FAILURE,
  FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST,
  GET_PEM_SUMMARY_TURNAROUND_DATA_SUCCESS,
  GET_PEM_SUMMARY_TURNAROUND_DATA_FAILURE,
  FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST,
  GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_SUCCESS,
  GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_FAILURE
} from '../actionTypes';

// Cost Data Actions
export const fetchPEMSummaryCostDataRequest = (payload: any) => ({
  type: FETCH_PEM_SUMMARY_COST_DATA_REQUEST,
  payload
});

export const setPEMSummaryCostData = (payload: any) => ({
  type: GET_PEM_SUMMARY_COST_DATA_SUCCESS,
  payload
});

export const fetchPEMSummaryCostDataError = (payload: any) => ({
  type: GET_PEM_SUMMARY_COST_DATA_FAILURE,
  payload
});

// Turnaround Data Actions
export const fetchPEMSummaryTurnaroundDataRequest = (payload: any) => ({
  type: FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST,
  payload
});

export const setPEMSummaryTurnaroundData = (payload: any) => ({
  type: GET_PEM_SUMMARY_TURNAROUND_DATA_SUCCESS,
  payload
});

export const fetchPEMSummaryTurnaroundDataError = (payload: any) => ({
  type: GET_PEM_SUMMARY_TURNAROUND_DATA_FAILURE,
  payload
});

// Service Quality Data Actions
export const fetchPEMSummaryServiceQualityDataRequest = (payload: any) => ({
  type: FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST,
  payload
});

export const setPEMSummaryServiceQualityData = (payload: any) => ({
  type: GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_SUCCESS,
  payload
});

export const fetchPEMSummaryServiceQualityDataError = (payload: any) => ({
  type: GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_FAILURE,
  payload
});